// extracted by mini-css-extract-plugin
export var button = "_ea-4";
export var hasDarkBackground = "_ea-7";
export var hasLightBackground = "_ea-6";
export var iconWrapper = "_ea-0";
export var large = "_ea-2";
export var medium = "_ea-1";
export var small = "_ea-5";
export var xsmall = "_ea-3";